if (!customElements.get('paired-product')) {
  customElements.define(
    'paired-product',
    class PairedProduct extends HTMLElement {
      connectedCallback() {
        const jsonEl = this.querySelector('[data-paired-product-json]');
        if (!jsonEl) return;

        try {
          this.pairedData = JSON.parse(jsonEl.textContent);
        } catch {
          return;
        }

        this.mainColorPosition = parseInt(this.dataset.mainColorPosition, 10) || null;
        this.pairedColorPosition = parseInt(this.dataset.pairedColorPosition, 10) || null;
        this.mediaEl = this.querySelector('.paired-product__media');
        this.cardLink = this.querySelector('.paired-product__card');

        this.onVariantChange = this.onVariantChange.bind(this);
        window.addEventListener('tabChange', this.onVariantChange);

        this.syncFromCurrentSelection();
      }

      disconnectedCallback() {
        window.removeEventListener('tabChange', this.onVariantChange);
      }

      syncFromCurrentSelection() {
        const productJsonEl = document.getElementById('product-json');
        const selectEl = document.querySelector('[id^="product-select-"]');
        if (!productJsonEl || !selectEl) return;

        try {
          const product = JSON.parse(productJsonEl.textContent);
          const variant = product.variants.find(
            (v) => String(v.id) === String(selectEl.value)
          );
          if (variant) this.updateForVariant(variant);
        } catch {
          /* ignore */
        }
      }

      onVariantChange(event) {
        if (event.detail) this.updateForVariant(event.detail);
      }

      getOptionValue(variant, position) {
        if (!position || !variant) return null;
        return variant[`option${position}`];
      }

      findPairedVariant(colorValue) {
        if (!colorValue || !this.pairedColorPosition) return null;

        return this.pairedData.variants.find(
          (variant) =>
            this.getOptionValue(variant, this.pairedColorPosition) === colorValue
        );
      }

      updateForVariant(mainVariant) {
        if (!this.mainColorPosition || !this.pairedColorPosition) return;

        const colorValue = this.getOptionValue(mainVariant, this.mainColorPosition);
        const pairedVariant = this.findPairedVariant(colorValue);
        const imageData =
          pairedVariant?.featured_image || this.pairedData.featuredImage;

        if (!imageData?.src) return;

        let imageEl = this.mediaEl?.querySelector('.paired-product__image');

        if (!imageEl || imageEl.tagName === 'svg') {
          imageEl = document.createElement('img');
          imageEl.className = 'paired-product__image';
          imageEl.loading = 'lazy';
          imageEl.alt = this.querySelector('.paired-product__title')?.textContent || '';
          this.mediaEl.innerHTML = '';
          this.mediaEl.appendChild(imageEl);
        }

        imageEl.src = imageData.src;
        if (imageData.srcset) imageEl.srcset = imageData.srcset;

        if (this.cardLink && pairedVariant) {
          this.cardLink.href = `${this.pairedData.url}?variant=${pairedVariant.id}`;
        } else if (this.cardLink) {
          this.cardLink.href = this.pairedData.url;
        }
      }
    }
  );
}
